export default {
  nativeBridge: undefined
}
